import {init, captureMessage, setUser} from '@sentry/browser';

global = typeof global !== 'undefined' ? global : window;
global.Sentry = {captureMessage};

init({
    dns: 'https://6519fdc23ff24b76b0ab4ff00a07f266@sentry.io/129311',
    release: typeof global.RELEASE !== 'undefined' ? global.RELEASE : null,
    environment: typeof global.ENVIRONMENT !== 'undefined' ? global.ENVIRONMENT : null,
    whitelistUrls: [
        /www\.master-plus\.com\.ua/,
        /master-plus\.com\.ua/,
        /dev\.master-plus\.com\.ua/,
        /dev\.master-plus\.ua/,
    ],
    ignoreUrls: [
        /\/inj_js\/common\.js/,
        /\/inj_js\/cpa\.js/,
        /\/inj_js\/meech\.js/,
        /\/1122/,
        /\/js\/tx\.js/,
        /\/gt2/,
        /\/app\/noext\/main\.php/,
        /\/1100/,
        /33C201AE-815F-3E40-B469-C66548031E89/,
        /C87E707B-19CA-DE4F-9544-DFA61B545359/,
        /inj_js/,
        /Internal Server Error/,
        /yndx_svtn_e/,
        /The operation is insecure./,
        /reachGoal/,
        /Blocked a frame with origin/,
    ],
    ignoreErrors: [
        '[object Event]',
        'Blocked a frame with origin',
        'out of memory',
        'An invalid exception was thrown',
        'A network error occurred',
        "Failed to execute 'drawImage' on",
        'NS_ERROR_NOT_AVAILABLE',
        'SkypeClick2Call',
        'NS_ERROR_FILE_NO_DEVICE_SPACE',
        "Cannot read property 'sfTimer' of null",
        'Could not complete the operation due to error',
        'Unexpected end of input',
        'Security error: attempted to read protected variable',
        '<unlabeled event>',
        'Недостаточно памяти',
        'Unexpected token ILLEGAL',
        'JSON syntax error',
        "Cannot convert 'g.navigator",
        'androidInterface',
        'navigator.getBattery is not a function',
        'Syntax error at line 15 while loading: multiple definitions of data property',
    ],
});

if (typeof global.USER_EMAIL !== 'undefined' || typeof global.USER_ID !== 'undefined') {
    setUser({
        email: global.USER_EMAIL,
        id: global.USER_ID,
    });
}
